(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    // Galaxy Gadgetz — custom language picker
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gg-lang]');
    if (!btn) return;

    var langCode  = btn.dataset.ggLang;
    var selectId  = btn.dataset.ggSelect;
    var select    = document.getElementById(selectId);
    if (!select) return;

    // Update hidden select value
    select.value = langCode;

    // Mark active state visually
    var list = btn.closest('.gg-lang-list');
    if (list) {
      list.querySelectorAll('.gg-lang-option').forEach(function (el) {
        el.classList.toggle('gg-lang-option--active', el === btn);
        el.setAttribute('aria-selected', el === btn ? 'true' : 'false');
      });
    }

    // Close the dropdown panel
    var component = btn.closest('dropdown-localization-component');
    if (component) {
      var panel = component.querySelector('[ref="panel"]');
      if (panel) panel.hidden = true;
      var triggerBtn = component.querySelector('[ref="button"]');
      if (triggerBtn) triggerBtn.setAttribute('aria-expanded', 'false');
    }

    // Trigger Shopify component's changeLanguage handler
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', function (e) {
    document.querySelectorAll('dropdown-localization-component').forEach(function (component) {
      if (!component.contains(e.target)) {
        var panel = component.querySelector('[ref="panel"]');
        if (panel) panel.hidden = true;
        var triggerBtn = component.querySelector('[ref="button"]');
        if (triggerBtn) triggerBtn.setAttribute('aria-expanded', 'false');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
